import React from "react";
import {
  textData as data,
  spheresData,
  SpheresDataType,
} from "../../content/data/SpheresData";
import {
  Container,
  Content,
  Description,
  FlexContainer,
  Title,
  TopLineFlex,
} from "./styles";
import { FlexScroll, OrderNumber, SvgWrapper } from "../Goods/styles";
import useIsMobile from "../../common/hooks/useIsMobile";

const Spheres = () => {
  const mappedSpheres = spheresData.map((el, ind) => (
    <SphereBlock props={el} key={`sphere-${ind}`} id={ind + 1} />
  ));

  const isMobile = useIsMobile()

  return <FlexScroll gap={isMobile ? "2vw" : "1vw"}>{mappedSpheres}</FlexScroll>;
};

const SphereBlock = ({ props, id }: { props: SpheresDataType; id: number }) => {
  const { title, desc, Svg, logoData } = props;

  return (
    <Container>
      <OrderNumber>
        {"("}0{id}
        {")"}
      </OrderNumber>
      <Content grow={1} direction="column">
        <SvgWrapper>
          <Svg />
        </SvgWrapper>
        <Title>{title}</Title>
        <FlexContainer grow={1} direction="column" justify="space-between">
          <Description>{desc}</Description>
          {logoData.length ? (
            <TopLineFlex gap="1vw" align="center">
              {logoData.map((Logo, index) => (
                <Logo key={index} />
              ))}
            </TopLineFlex>
          ) : null}
        </FlexContainer>
      </Content>
    </Container>
  );
};

export default Spheres;
